import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import Error404 from '../../Error404';
import Teams from './Teams';

const TeamWrapper = () => {
  return (
    <Switch>
      <Route path={ROUTES?.TEAMS} component={Teams} />
      <Route path="*" component={Error404} />
    </Switch>
  );
};

export default TeamWrapper;
